export const uglify = (numStr: string) => {
  if (numStr) {
    const cleanNumberStr = numStr.replaceAll('$', '').replaceAll(',', '');
    const isNumberHasMoreThan2NumbersAfterDot = (cleanNumberStr.length - 3) - cleanNumberStr.indexOf('.') > 0;
    const number = parseFloat(cleanNumberStr);
    if (!Number.isNaN(number)) {
      if (isNumberHasMoreThan2NumbersAfterDot) {
        return parseFloat(number.toFixed(2));
      }
      return number;
    }
  }
  return undefined;
};

export const prettify = (number: number) => {
  const isNumberInteger = Number.isInteger(number);
  if (isNumberInteger) return `$${number.toLocaleString()}.00`;

  const addOneZero = `${number}`.length - `${number}`.indexOf('.') === 2;
  if (addOneZero) return `$${number.toLocaleString()}0`;

  const isNumberHas2SignsAfterDot = `${number}`.length - `${number}`.indexOf('.') === 3;
  if (isNumberHas2SignsAfterDot) return `$${number.toLocaleString()}`;

  const isNumberHasMoreThan2NumbersAfterDot = `${number}`.length - `${number}`.indexOf('.') > 3;
  if (isNumberHasMoreThan2NumbersAfterDot) {
    const dotIndex = `${number}`.indexOf('.');
    const formattedNumber = parseFloat(`${number}`.substring(0, dotIndex + 3));
    return `$${formattedNumber.toLocaleString()}`;
  }
  return '$0.00';
};
